

export class VehicleModelOutputWithStatus implements IVehicleModelOutputWithStatus {
    /** The auto-generated id of the vehicle model master */
    vehicle_model_id!: number;
    /** The vehicle model name with 255 character limit */
    vehicle_model_name!: string;
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id!: number;
    /** The vehicle company name with 255 character limit */
    vehicle_company_name!: string;
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id!: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name!: string;
    /** The auto-generated id of the fuel type master */
    fuel_type_id!: number;
    /** The fuel type name with 255 character limit */
    fuel_type_name!: string;
    /** The number of seats of vehicle */
    no_of_seats!: number;
    /** The max load capacity  of vehicle */
    max_load_capacity!: number;
    /** The air conditioner flag for vehicle for availability of air conditioner */
    air_conditioner!: number;
    /** The application module image with 2048 character limit */
    vehicle_icon!: string;
    /** Manage status of vehicle model. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IVehicleModelOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_model_id = _data["vehicle_model_id"];
            this.vehicle_model_name = _data["vehicle_model_name"];
            this.vehicle_company_id = _data["vehicle_company_id"];
            this.vehicle_company_name = _data["vehicle_company_name"];
            this.vehicle_type_id = _data["vehicle_type_id"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.fuel_type_id = _data["fuel_type_id"];
            this.fuel_type_name = _data["fuel_type_name"];
            this.no_of_seats = _data["no_of_seats"];
            this.max_load_capacity = _data["max_load_capacity"];
            this.air_conditioner = _data["air_conditioner"];
            this.vehicle_icon = _data["vehicle_icon"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleModelOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_model_id"] = this.vehicle_model_id;
        data["vehicle_model_name"] = this.vehicle_model_name;
        data["vehicle_company_id"] = this.vehicle_company_id;
        data["vehicle_company_name"] = this.vehicle_company_name;
        data["vehicle_type_id"] = this.vehicle_type_id;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["fuel_type_id"] = this.fuel_type_id;
        data["fuel_type_name"] = this.fuel_type_name;
        data["no_of_seats"] = this.no_of_seats;
        data["max_load_capacity"] = this.max_load_capacity;
        data["air_conditioner"] = this.air_conditioner;
        data["vehicle_icon"] = this.vehicle_icon;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleModelOutputWithStatus {
    /** The auto-generated id of the vehicle model master */
    vehicle_model_id: number;
    /** The vehicle model name with 255 character limit */
    vehicle_model_name: string;
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id: number;
    /** The vehicle company name with 255 character limit */
    vehicle_company_name: string;
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name: string;
    /** The auto-generated id of the fuel type master */
    fuel_type_id: number;
    /** The fuel type name with 255 character limit */
    fuel_type_name: string;
    /** The number of seats of vehicle */
    no_of_seats: number;
    /** The max load capacity  of vehicle */
    max_load_capacity: number;
    /** The air conditioner flag for vehicle for availability of air conditioner */
    air_conditioner: number;
    /** The application module image with 2048 character limit */
    vehicle_icon: string;
    /** Manage status of vehicle model. 0 For De-active, 1 For Active */
    status: number;
}

